function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_225",
  "data-name": "Group 225",
  transform: "translate(9.714 22.965)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_79",
  "data-name": "Path 79",
  className: "cls-1",
  d: "M94.444,195.384a.957.957,0,0,1-.871-.558l-2.085-4.563-.083.182a.958.958,0,0,1-.871.558h-12.8a.953.953,0,1,1,0-1.905h12.18l.7-1.531a.959.959,0,0,1,1.743,0l2.085,4.563,4.963-10.859a.959.959,0,0,1,1.743,0l3.283,7.183,1.043-2.281a.959.959,0,0,1,1.743,0l1.337,2.925h12.841a.953.953,0,1,1,0,1.905H107.938a.957.957,0,0,1-.871-.558l-.72-1.576L105.3,191.15a.959.959,0,0,1-1.743,0l-3.283-7.183-4.963,10.859A.958.958,0,0,1,94.444,195.384Z",
  transform: "translate(-76.779 -180.713)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_227",
  "data-name": "Group 227"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_226",
  "data-name": "Group 226"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_80",
  "data-name": "Path 80",
  className: "cls-1",
  d: "M40.2,65H33.226a.956.956,0,1,1,0-1.912H40.2a2.8,2.8,0,0,0,2.794-2.794V43.947a.956.956,0,0,1,.956-.956H60.294A2.8,2.8,0,0,0,63.088,40.2V24.8a2.8,2.8,0,0,0-2.794-2.794H43.947a.956.956,0,0,1-.956-.956V4.706A2.8,2.8,0,0,0,40.2,1.912H24.8a2.8,2.8,0,0,0-2.794,2.794v9.7a.956.956,0,0,1-1.912,0v-9.7A4.711,4.711,0,0,1,24.8,0H40.2A4.711,4.711,0,0,1,44.9,4.706V20.1H60.294A4.711,4.711,0,0,1,65,24.8V40.2A4.711,4.711,0,0,1,60.294,44.9H44.9V60.294A4.711,4.711,0,0,1,40.2,65ZM28.39,65H24.8A4.711,4.711,0,0,1,20.1,60.294V44.9H4.706A4.711,4.711,0,0,1,0,40.2V24.8A4.711,4.711,0,0,1,4.706,20.1H20.1v-1.33a.956.956,0,0,1,1.912,0v2.286a.956.956,0,0,1-.956.956H4.706A2.8,2.8,0,0,0,1.912,24.8V40.2a2.8,2.8,0,0,0,2.794,2.794H21.053a.956.956,0,0,1,.956.956V60.294A2.8,2.8,0,0,0,24.8,63.088H28.39a.956.956,0,1,1,0,1.912ZM40.2,61.348H24.8a1.056,1.056,0,0,1-1.054-1.054V41.354a.1.1,0,0,0-.1-.1H4.706A1.056,1.056,0,0,1,3.652,40.2V24.8a1.055,1.055,0,0,1,1.054-1.054h18.94a.1.1,0,0,0,.1-.1V4.706A1.056,1.056,0,0,1,24.8,3.651H40.2a1.056,1.056,0,0,1,1.054,1.054v18.94a.1.1,0,0,0,.1.1h18.94A1.056,1.056,0,0,1,61.349,24.8V40.2a1.056,1.056,0,0,1-1.054,1.054H51.258a.956.956,0,0,1,0-1.912h8.179V25.66H41.354a2.016,2.016,0,0,1-2.014-2.014V5.563H25.66V23.646a2.016,2.016,0,0,1-2.014,2.014H5.563V39.34H23.646a2.016,2.016,0,0,1,2.014,2.014V59.437H39.34V41.354a2.016,2.016,0,0,1,2.014-2.014h5.284a.956.956,0,1,1,0,1.912H41.354a.1.1,0,0,0-.1.1v18.94A1.055,1.055,0,0,1,40.2,61.348Z",
  transform: "translate(0 0)"
})));

var SvgUrgent = function SvgUrgent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0423\\u0440\\u0433\\u0435\\u043D\\u0442\\u043D\\u0456",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUrgent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/urgent.d06bc951.svg";
export { ForwardRef as ReactComponent };